import React from 'react'
import Wildcard from './Wildcard'

const Form = ({
  name, data, onChange, showErrors, mode, innerForm = false, parentIsSorting = false,
}) => (
  <div className={`${innerForm ? '' : 'p-4 bg-white'}`}>
    <div className="flex flex-wrap">
      {typeof data.models[name] !== 'undefined'
        && data.models[name].map(item => (
          <Wildcard
            mode={mode}
            onChange={onChange}
            showErrors={showErrors}
            storedData={data.stored}
            languages={data.languages}
            find={data.find}
            files={data.files}
            key={item.name}
            {...item}
            models={['models', 'model'].includes(item.type) ? data.models : null}
            innerForm={innerForm}
            parentIsSorting={parentIsSorting}
          />
        ))}
    </div>
  </div>
)

export default Form
